import { Navigate } from "react-router-dom";
import { useDefaultAppRoute } from "../../hooks/useIsAdvertisersDemo";

export const PublicRoute = ({ children, restricted, isLogged }) => {
  const defaultRoute = useDefaultAppRoute();

  if (isLogged && restricted) {
    return <Navigate to={defaultRoute} />;
  }

  return children;
};
